import { CheckIcon, Loader2Icon, XIcon } from 'lucide-react';
import { TextLink } from '../text-link/TextLink';
import { Tooltip } from '../tooltip/Tooltip';
import { PermissionGuard, type PermissionCheck } from '@/features/auth';

interface InlineEditRowActionsProps {
    isPending: boolean;
    onAccept: () => void;
    onCancel: () => void;
    acceptLabel?: string;
    cancelLabel?: string;
    // Gates the accept control only, so callers that permission-gate saving
    // (but not cancelling) keep that behaviour; omit to leave it ungated.
    acceptPermission?: PermissionCheck;
}

export const InlineEditRowActions: React.FC<InlineEditRowActionsProps> = ({
    isPending,
    onAccept,
    onCancel,
    acceptLabel = 'Save changes',
    cancelLabel = 'Cancel',
    acceptPermission,
}) => {
    if (isPending) {
        return (
            <div role="status" aria-live="polite" className="flex items-center">
                <Loader2Icon size={18} className="animate-spin text-mp-muted" />
                <span className="sr-only">Saving…</span>
            </div>
        );
    }

    const acceptButton = (
        <Tooltip content={acceptLabel}>
            <TextLink
                color="success"
                ariaLabel={acceptLabel}
                startIcon={<CheckIcon size={18} />}
                onClick={onAccept}
            />
        </Tooltip>
    );

    return (
        <div className="flex gap-2">
            {acceptPermission ? (
                <PermissionGuard permission={acceptPermission}>{acceptButton}</PermissionGuard>
            ) : (
                acceptButton
            )}
            <Tooltip content={cancelLabel}>
                <TextLink
                    color="neutral"
                    ariaLabel={cancelLabel}
                    startIcon={<XIcon size={18} />}
                    onClick={onCancel}
                />
            </Tooltip>
        </div>
    );
};
